import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import Select from "react-select";

import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchData,
  fetchExport,
} from "./specialDiscSlice";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import {
  CallApiExport,
  createChangeHandler,
  getValueStatus,
  paramsMasterAll,
  setOptionsMaster,
  showErrorDialog,
} from "../../utility";
import { SpecialDiscTable } from "./SpecialDiscTable";
import { fetchBranch, selectBranch } from "../branch/branchSlice";
import { InputDateRange } from "../../utility/InputDateRange";
import { fetchParam, selectDataParam } from "../param/paramSlice";

export const SpecialDiscPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectData);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const dataBranch = useSelector(selectBranch);
  const dataParam = useSelector(selectDataParam);

  // Filter
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [group, setGroup] = useState("");
  const [branch, setBranch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [optionsBranch, setOptionsBranch] = useState([]);
  const [optionsGroup, setOptionsGroup] = useState([]);

  useEffect(() => {
    // Reset on first load
    dispatch(resetData());
  }, [dispatch]);

  useEffect(() => {
    async function fetchMyAPI() {
      await dispatch(fetchData({ pageNo: 1, pageSize: 10 }));
      await dispatch(fetchBranch(paramsMasterAll));
      await dispatch(
        fetchParam({
          ...paramsMasterAll,
          param_group_code: "CUSTOMER_GROUP",
          is_active: true,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataBranch && dataBranch.length > 0) {
      setOptionsMaster(
        dataBranch,
        setOptionsBranch,
        "branch_code",
        "branch_name"
      );
    }
  }, [dataBranch]);
  useEffect(() => {
    if (dataParam.length > 0) {
      setOptionsMaster(dataParam, setOptionsGroup, "param_code", "param_value");
    }
  }, [dataParam]);

  const paramsFilter = {
    special_discount_code: code,
    branch_code: branch,
    start_at: startDate,
    end_at: endDate,
    customer_group: group,
  };

  const handleSearch = async () => {
    const params = {
      ...paramsFilter,
      pageNo: 1,
      pageSize: 10,
    };

    try {
      const response = await dispatch(fetchData(params));
      if (response.payload.data.status_code === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      const params = {
        ...paramsFilter,
        pageNo: page,
        pageSize: sizePerPage,
      };
      try {
        const response = await dispatch(fetchData(params));
        if (response.payload.data.status_code === 200) {
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      const response = await dispatch(
        fetchData({
          ...paramsFilter,
          sort_order: sortOrder,
          sort_field: sortField,
          pageNo: 1,
          pageSize: sizePerPage,
        })
      );
      let result;
      if (sortOrder === "asc") {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
        console.log(result, "desc");
      }
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };
  const handleChangeBranch = createChangeHandler(setBranch);
  const handleChangeGroup = createChangeHandler(setGroup);

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <Card>
      <CardHeader title="Special Discount">
        <CardHeaderToolbar>
          <Button
            className="btn btn-outline-danger mr-4"
            onClick={() =>
              CallApiExport(paramsFilter, fetchExport, dispatch, "Special_Disc")
            }
          >
            Export
          </Button>
          <Button
            className="btn btn-danger"
            onClick={() => history.push("/master/special-disc/create")}
          >
            Create
          </Button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        {/* Filter */}
        <Form className="mb-5">
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Discount</b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    type="text"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    onKeyPress={handleKeyPress}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Period</b>
                </Form.Label>
                <Col sm={6}>
                  <InputDateRange
                    setEndDate={setEndDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    startDate={startDate}
                    CallApi={fetchData}
                    paramsFilter={paramsFilter}
                    paramsStart={"start_at"}
                    paramsEnd={"end_at"}
                    hidden={false}
                  />
                </Col>
              </Form.Group>
            </Col>

            {/* Right Row */}

            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Branch</b>
                </Form.Label>
                <Col sm={6}>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={optionsBranch}
                    value={getValueStatus(branch, optionsBranch)}
                    placeholder="Select ..."
                    onChange={handleChangeBranch}
                    isClearable={true}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Customer Group</b>
                </Form.Label>
                <Col sm={6}>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={optionsGroup}
                    value={getValueStatus(group, optionsGroup)}
                    placeholder="Select ..."
                    onChange={handleChangeGroup}
                    isClearable={true}
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row}>
                <Col sm={3}>
                  <Button
                    className="btn btn-outline-danger"
                    onClick={handleSearch}
                  >
                    Search
                  </Button>
                </Col>
                {/* <Col sm={3}>
                  <Button
                    className="btn btn-warning"
                    onClick={() => history.push("/masterdata/vendor-create")}
                  >
                    Create
                  </Button>
                </Col> */}
              </Form.Group>
            </Col>
          </Form.Group>
        </Form>

        {/* Table */}
        <SpecialDiscTable
          data={Array.isArray(data) ? data : []}
          page={pageNo}
          sizePerPage={pageSize}
          totalSize={totalRecord}
          onTableChange={handleTableChange}
          loading={loading}
        />
      </CardBody>
    </Card>
  );
};
